$(document).ready(function () {
    adapativWhyWe();
});

$(window).resize(function () {
    adapativWhyWe();
});

function adapativWhyWe() {
    var w = $(window).width();
    if (w < 1200) {
        $('.whyWe-items').addClass('owl-carousel');
        $('.whyWe-items').removeClass('row');
        initOwlWhyWe();
        return;
    } else {
        $('.whyWe-items').trigger('destroy.owl.carousel');
    }

}

function initOwlWhyWe() {
    $('.whyWe-items').owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        margin: 5,
        items: 2,
        autoplay: false,
        responsive: {
            992: {
                items: 2,
                margin: 30,
            },
            0: {
                items: 1,
                margin: 20,
            }
        }
    });

}

$(".news-slider-navPrev").click(function() {
    $('.tilesItemsCarousel').trigger('prev.owl.carousel');
});

$(".news-slider-navNext").click(function () {
    $('.tilesItemsCarousel').trigger('next.owl.carousel');
});

$('.tilesItemsCarousel').on('changed.owl.carousel', function(event) {
    $('.news-paginate .paginate-curent').text(event.item.index+1);

});

$('.news-paginate .paginate-allPage').text($('.news-items .owl-dot').length);



